<div>
    <div class="row {{ inactiveClass }}">
        <div class="col-xs-3" *ngIf="!isGift">
            <div class="rat-3-4">
                <div class="rat-content" (click)="clickOnProduct()">
                    <img class="img-responsive" [src]="itemImagesUrl?.main" alt="" />
                </div>
            </div>
        </div>
        <div class="col-xs-3 col-sm-2" *ngIf="isGift">
            <div class="rat-3-4">
                <div class="rat-content">
                    <img class="img-responsive" [src]="giftImage" alt="" />
                </div>
            </div>
        </div>
        <div class="col-xs-9 is-flex content-sp-between flex-column">
            <div>
                <div (click)="clickOnProduct()">
                    <div class="title-s ttu mb-8" *ngIf="isLastUnits$ | async">
                        {{ 'dev.product.item.cart.lastUnits' | translate }}
                    </div>
                    <div class="title-m ttu item-name" *ngIf="!isGift">{{ product.name }}</div>
                    <div>
                        <ng-container
                            *ngIf="{
                                prices: itemPrices$ | async,
                                classPrices: classPrices$ | async
                            } as data"
                        >
                            <formatted-price
                                [price]="data.prices.price.value"
                                [secondaryPrice]="data.prices.oldPrice.value"
                                [terciaryPrice]="data.prices.originalPrice.value"
                                [lastReducedPrice]="data.prices.lastReducedPrice.value"
                                [options]="{
                                    showAlternateCurrencies: false,
                                    noBreakPrice: true
                                }"
                                [pricesClasses]="data.classPrices"
                                [pricesStyles]="{
                                    cmsStyles: priceStyles$ | async
                                }"
                            >
                                <!-- Percent Price only enabled triple -->
                                <ng-container primaryText *ngIf="data.prices.percent.placePrice">
                                    <label class="text-l">
                                        -{{ data.prices.percent.value }}%
                                        <label *ngIf="data.prices.percent.showDisclaimer">*</label>
                                    </label>
                                </ng-container>
                                <!-- Text Promotions VEA PREWARM -->
                                <ng-container pricesPromotion *ngIf="!hidePriceText && discountText$ | async as discount">
                                    <span class="text-m" *ngIf="discount.promotionInfo" (click)="openSuscriptionJoin(discount.cta)">{{
                                        discount.key | translate
                                    }}</span>
                                </ng-container>
                            </formatted-price>
                        </ng-container>
                    </div>
                    <div *ngIf="product.status.showReference" class="title-m c-dark-grey">
                        {{ 'dev.shopCart.item.ref' | translate }}
                        <span>{{ product.displayReference }}/{{ product.status.selectedColor.id }}</span>
                    </div>
                    <div class="title-m ttu item-name" *ngIf="isGift">{{ 'dev.cart.giftBox' | translate }}</div>
                    <div *ngIf="showColor && itemImagesUrl?.color" class="is-flex flex-row mt-16 ttu">
                        <div class="pr-8">
                            <div class="text-m pt-4">{{ sizeName }}</div>
                        </div>
                        <span class="text-m pt-4">|</span>
                        <div class="pl-8">
                            <div class="text-m pt-4">{{ colorName }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-3 is-flex content-end">
                    <ng-content select="[actions]"></ng-content>
                </div>
            </div>

            <ng-container *ngIf="product.customization">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="mt-24 text-l is-flex">
                            <div class="text-l ttu pr-8">{{ 'dev.shopCart.item.customized' | translate }}</div>
                            <span class="text-l ttu" *ngIf="product.customization.text">|</span>
                            <div class="ttu pl-8" *ngIf="product.customization.text">{{ product.customization.text }}</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
